import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';

import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@Component({
  standalone: true,
  selector: 'app-select-modal',
  imports: [
    ReactiveFormsModule,
    NzInputModule,
    NzModalModule,
    NzRadioModule,
    NzIconModule
],
  templateUrl: './select-modal.component.html',
  styleUrls: ['./select-modal.component.scss'],
})
export class SelectModalComponent implements OnInit {
  @Input() propertyForm: UntypedFormGroup;
  @Input() isMobile = true;
  @Input() showValue;
  @Input() tenList;
  @Input() controlName;
  @Input() title: string;
  @Input() placeholder
  @Input() isRadio:boolean=true;
  formArray=[];


  constructor() { }

  ngOnInit() {
if(!this.isRadio){ 
  // this.formArray=this.propertyForm['controls'][this.controlName].value;
}
  }
  isVisibleMobile = false;
 
  showModalForMobile() {
    this.isVisibleMobile = true;
  }

  handleOk(): void {
    this.isVisibleMobile = false;
  }

  handleCancelMobile(): void {
    this.isVisibleMobile = false;
  }

  blurThis(i:string){
      let a=document.querySelector(i);
      //a.blur();
  }

  isPresent(n,control){
    
    if(this.propertyForm['controls'][control].value){
    }else{
     // this.formArray=[...this.propertyForm['controls'][control].value]
     this.propertyForm['controls'][this.controlName].patchValue(this.formArray);
    }
    let index=this.formArray.indexOf(n);
    if(index>-1){
      this.formArray.splice(index);
      this.propertyForm['controls'][this.controlName].patchValue(this.formArray);
  }else{
        this.formArray.push(n);
        this.propertyForm['controls'][this.controlName].patchValue(this.formArray);
  }
}

  handleArray(name,index,cN){
    
    this.isPresent(name,cN);
    
  }
  


  
}

